const normalized = (value) =>
  String(value ?? '')
    .trim()
    .toLocaleLowerCase('ko-KR');
const strings = (values) => new Set(values.map((v) => String(v ?? '')).filter(Boolean));
export function recordSearchEntities(result) {
  const albums = result?.albums?.items ?? [],
    artists = result?.artists?.items ?? [],
    playlists = result?.playlists?.items ?? [];
  return {
    albumIds: strings(albums.map((x) => x.albumId ?? x.id)),
    albumSourceIds: strings(albums.map((x) => x.sourceId)),
    albumTitles: strings(albums.map((x) => normalized(x.title))),
    artistSourceIds: strings([
      ...artists.map((x) => x.id ?? x.artistId),
      ...albums.map((x) => x.artist?.sourceId),
    ]),
    artistNames: strings([
      ...artists.map((x) => normalized(x.name)),
      ...albums.map((x) => normalized(x.artist?.name)),
    ]),
    playlistIds: strings(playlists.map((x) => x.id)),
    playlistTitles: strings(playlists.map((x) => normalized(x.title))),
  };
}
function matchesName(names, value) {
  const text = normalized(value);
  return !!text && [...names].some((name) => text.includes(name) || name.includes(text));
}
export function filterRecordSearch(items = [], query = '', tab, entities = recordSearchEntities()) {
  const q = normalized(query);
  if (!q) return items;
  return items.filter((x) => {
    const text = (...values) => values.some((v) => normalized(v).includes(q));
    const albumId = entities.albumIds.has(String(x.album?.id ?? ''));
    const sourceId = entities.albumSourceIds.has(String(x.album?.sourceId ?? ''));
    const playlistId = entities.playlistIds.has(String(x.list?.id ?? ''));
    if (tab === 'tracks') return text(x.title, x.artistName, x.albumTitle);
    if (tab === 'ratings' || tab === 'reviews')
      return (
        text(x.album?.title, x.artist?.name, x.review?.content, x.album?.genres?.join(' ')) ||
        albumId ||
        sourceId ||
        entities.artistSourceIds.has(String(x.artist?.sourceId ?? ''))
      );
    if (tab === 'lists')
      return (
        text(x.title, x.type) ||
        entities.playlistIds.has(String(x.id)) ||
        matchesName(entities.playlistTitles, x.title)
      );
    const names =
      matchesName(entities.albumTitles, x.album?.title) ||
      matchesName(entities.artistNames, x.artist?.name) ||
      matchesName(entities.playlistTitles, x.list?.title);
    if (tab === 'comments')
      return (
        text(x.comment?.content, x.album?.title, x.artist?.name, x.list?.title, x.notice?.title) ||
        albumId ||
        playlistId ||
        names
      );
    return (
      text(
        x.album?.title,
        x.artist?.name,
        x.review?.content,
        x.author?.nickname,
        x.list?.title,
        x.notice?.title,
        x.feed?.title,
      ) ||
      albumId ||
      sourceId ||
      playlistId ||
      names
    );
  });
}
